import React, { PureComponent } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { persistor, store } from 'redux/store';
import translation from 'shared/constant/translation';

import NavProvider from 'route/NavProvider';

export default class Main extends PureComponent {
  render() {
    const httpLink = {
      uri: process.env.AUDIT_URL,
      headers: {
        'content-type': 'application/json',
        'access-control-allow-origin': '*',
        'x-hasura-admin-secret': process.env.AUDIT_KEY,
      },
    };

    const client = new ApolloClient({
      link: new HttpLink(httpLink),
      cache: new InMemoryCache(),
    });

    return (
      <Provider store={store}>
        <ApolloProvider client={client}>
          <PersistGate loading={null} persistor={persistor}>
            <IntlProvider locale="id" messages={translation.id}>
              <NavProvider />
            </IntlProvider>
          </PersistGate>
        </ApolloProvider>
      </Provider>
    );
  }
}
